import merge from 'lodash/merge'

import fr from '@shared/i18n/locales/fr'

export default merge(fr, {
  vc: {
    http: {
      errors: {
        widgetsList: 'Failed to fetch a list of widgets',
        quickForm: 'Failed to fetch a quick form data',
        quickSignTemplate: 'Failed to fetch a Quick Sign Template data',
      },
    },
    tac: {
      banner: {
        declined: 'Terms and Conditions are declined',
        presented: 'Terms and Conditions are presented',
        accepted: 'Terms and Conditions are accepted',
        remindToAccept: 'Remind to accept',
      },
      messageBody:
        'You have not agreed to the Terms and Conditions. We can not proceed with the conversation until you agree. Please click the link and accept the Terms and Conditions.',
      messageSubject: 'Terms and Conditions',
      sendReminder: 'Send reminder',
      reminderDialogtitle: 'Send Reminder to ',
    },
    labels: {
      emr: 'Emr',
      private: 'Private',
      translate: 'Translate',
      privatePatient: 'Is private patient',
      createNewPatient: 'Create New Patient',
      search: 'Search',
      createNew: 'Create new',
      chatWidgetToSend: 'Chat widget to send',
      widgetNumber: 'Widget Number',
      searchForm: 'Find form',
      forms: 'Forms',
      pleaseSelectWidget: 'Please select a widget to start a conversation',
    },
    messages: {
      doesntExist: 'does not exist',
    },
    start: 'Start',
    quickSign: {
      savedSuccess: 'Quick Sign Template saved successfully',
      savedError: 'Failed to save Quick Sign Template',
      viewTemplates: 'View templates',
      saveAsTemplate: 'Save as Template',
      templateName: 'Template Name',
      templateNamePaceholder: 'Enter Template Name',
      templateModalTitle: 'Pick a Quick Sign Template',
      filterPrivate: 'Filter only private',
      preview: 'Preview',
      findTemplate: 'Find Quick Sign template',
      openTempleteEdit: 'View Template',
      selectTemplate: 'Select a Template to preview',
    },
  },
})
